import { render, staticRenderFns } from "./docs.vue?vue&type=template&id=a22047a2&scoped=true&"
import script from "./docs.vue?vue&type=script&lang=js&"
export * from "./docs.vue?vue&type=script&lang=js&"
import style0 from "./docs.vue?vue&type=style&index=0&id=a22047a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22047a2",
  null
  
)

export default component.exports